import { render, staticRenderFns } from "./gateAlert.vue?vue&type=template&id=019b3098&scoped=true"
import script from "./gateAlert.vue?vue&type=script&lang=js"
export * from "./gateAlert.vue?vue&type=script&lang=js"
import style0 from "./gateAlert.vue?vue&type=style&index=0&id=019b3098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b3098",
  null
  
)

export default component.exports